import { useEffect } from 'react';

const ContentProtector = () => {
    useEffect(() => {
        const preventRightClick = (e) => {
            e.preventDefault();
        };

        const preventCopy = (e) => {
            e.preventDefault();
        };

        const preventDoubleClick = (e) => {
            if (e.detail > 1) e.preventDefault();
        };

        const preventShortcuts = (e) => {
            if (
                e.ctrlKey &&
                (e.key === 'u' || e.key === 's' || e.key === 'p' || e.key === 'c')
            ) {
                e.preventDefault();
            }
            if (e.key === 'F12') {
                e.preventDefault();
            }
        };

        const detectPrintScreen = (e) => {
            if (e.key === 'PrintScreen') {
                document.body.style.filter = 'blur(10px)';
                setTimeout(() => {
                    document.body.style.filter = 'none';
                }, 1000);
            }
        };

        // Disable drag, right-click and Lens access on images
        const disableImageProtection = () => {
            const imgs = document.querySelectorAll('img');
            imgs.forEach((img) => {
                img.setAttribute('draggable', 'false');
                img.setAttribute('oncontextmenu', 'return false');
                img.style.pointerEvents = 'none';
                img.style.userSelect = 'none';
                img.style.webkitUserDrag = 'none';
                img.style.userDrag = 'none';
            });
        };

        // Add transparent overlay to confuse AI capture
        const addLensBlockOverlay = () => {
            const overlay = document.createElement('div');
            overlay.setAttribute('id', 'lens-blocker');
            overlay.style.position = 'fixed';
            overlay.style.top = 0;
            overlay.style.left = 0;
            overlay.style.width = '100vw';
            overlay.style.height = '100vh';
            overlay.style.zIndex = '9999';
            overlay.style.pointerEvents = 'none';
            overlay.style.background = 'transparent';
            overlay.style.backdropFilter = 'none'; // optional: blur(1px)
            document.body.appendChild(overlay);
        };

        // Add watermark overlay for images (optional)
        const addWatermarkOverlay = () => {
            const watermark = document.createElement('div');
            watermark.innerText = '© Lavanya Infotech';
            watermark.style.position = 'fixed';
            watermark.style.bottom = '10px';
            watermark.style.right = '10px';
            watermark.style.fontSize = '12px';
            watermark.style.color = 'rgba(255,255,255,0.2)';
            watermark.style.zIndex = '9999';
            document.body.appendChild(watermark);
        };

        // Add all listeners
        document.addEventListener('contextmenu', preventRightClick);
        document.addEventListener('copy', preventCopy);
        document.addEventListener('mousedown', preventDoubleClick);
        document.addEventListener('keydown', preventShortcuts);
        document.addEventListener('keyup', detectPrintScreen);

        // Disable selection
        document.body.style.userSelect = 'none';

        // Activate protections
        disableImageProtection();
        addLensBlockOverlay();
        addWatermarkOverlay();

        return () => {
            document.removeEventListener('contextmenu', preventRightClick);
            document.removeEventListener('copy', preventCopy);
            document.removeEventListener('mousedown', preventDoubleClick);
            document.removeEventListener('keydown', preventShortcuts);
            document.removeEventListener('keyup', detectPrintScreen);
            document.body.style.userSelect = 'auto';

            const lensBlock = document.getElementById('lens-blocker');
            if (lensBlock) lensBlock.remove();
        };
    }, []);

    return null;
};

export default ContentProtector;
